/**
 * Labstep
 *
 * @module components/Folder/Breadcrumb/Item
 * @desc Breadcrumb Item for Folder
 */

import { FolderFormShowEditName } from 'labstep-web/components/Folder/Form/ShowEdit/Name';
import FolderToggleIncludeSubfolders from 'labstep-web/components/Folder/ToggleIncludeSubfolders';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { Breadcrumb } from 'labstep-web/core/Breadcrumb';
import type { IBreadcrumbLink } from 'labstep-web/core/Breadcrumb/types';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type {
  FolderBreadcrumbItemProps,
  OuterFolderBreadcrumbItemProps,
} from './types';

export const OuterFolderBreadcrumbItem: React.FC<
  OuterFolderBreadcrumbItemProps
> = ({ folder }) => {
  if (!folder.outer_folder) {
    return null;
  }
  const links: IBreadcrumbLink[] = [];

  let outer_folder: Folder | undefined = folder.outer_folder;
  while (outer_folder) {
    links.unshift({
      route: {
        to: `${folder.type}_index`,
        query: {
          folder_id: outer_folder.guid,
        },
      },
      name: outer_folder.name,
      icon: 'folder',
    });
    outer_folder = outer_folder.outer_folder;
  }

  return (
    <>
      {' '}
      <Breadcrumb links={links} />
      <Icon name="chevron right" size="small" color="grey" />
    </>
  );
};

export const FolderBreadcrumbItem: React.FC<
  FolderBreadcrumbItemProps
> = ({ searchParams, folderType }) => (
  <>
    {searchParams.is_unsorted && (
      <Desktop>
        {({ match }) =>
          match ? (
            <div style={{ minWidth: '200px' }}>
              <span>Unsorted</span>
            </div>
          ) : (
            <span>Unsorted</span>
          )
        }
      </Desktop>
    )}
    {searchParams.folder_id && (
      <EntityReadEntityContainer
        entityName={Folder.entityName}
        id={searchParams.folder_id as string}
      >
        {({ entity }) => (
          <Flex grow>
            {entity && (
              <Desktop>
                {({ match }) =>
                  match ? (
                    <Flex
                      grow
                      style={{
                        alignItems: 'baseline',
                      }}
                      spacing="between"
                    >
                      <Flex
                        style={{
                          alignItems: 'baseline',
                          flexWrap: 'wrap',
                        }}
                        grow
                      >
                        <OuterFolderBreadcrumbItem folder={entity} />
                        <Flex
                          grow
                          style={{
                            alignItems: 'baseline',
                          }}
                          spacing="between"
                        >
                          <Flex
                            style={{
                              alignItems: 'baseline',
                              margin: '5px',
                            }}
                            spacing="between"
                          >
                            <Icon name="folder open" />
                            <FolderFormShowEditName folder={entity} />
                          </Flex>

                          <FolderToggleIncludeSubfolders
                            folderType={folderType}
                          />
                        </Flex>
                      </Flex>
                    </Flex>
                  ) : (
                    <span>{entity.name}</span>
                  )
                }
              </Desktop>
            )}
          </Flex>
        )}
      </EntityReadEntityContainer>
    )}
  </>
);
